import Vue from 'vue'
import VueRouter from 'vue-router'
import Form from '../views/Form.vue'
import Validation from '../views/Validation.vue'
import PageNotFound from '../views/PageNotFound.vue'

import conf from '../config/conf'

Vue.use(VueRouter)

const routes = [
  {
    path: '/form/:id',
    name: 'form',
    component: Form
  },

  {
    path: '/validation',
    name: 'validation',
    component: Validation
  },

  {
    path: '/*',
    name: '404',
    component: PageNotFound
  },
]

if (conf.urlDefaultPath) {
  routes.forEach((route) => {
    route.path = '/' + conf.urlDefaultPath + route.path
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
